import { render } from "./signInSuccess.vue?vue&type=template&id=48d247f1&scoped=true"
import script from "./signInSuccess.vue?vue&type=script&lang=js"
export * from "./signInSuccess.vue?vue&type=script&lang=js"

import "./signInSuccess.vue?vue&type=style&index=0&id=48d247f1&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d247f1"]])

export default __exports__